<template>
  <div class="space-y-4">
    <div
      class="bg-ontick-graphite-500 space-y-6 rounded px-4 py-6 shadow sm:p-10"
    >
      <!-- <button @click="$emit('goToRegisterCheck')">
        <i v-html="$icons.chevron_left"></i>
      </button> -->
      <h2 class="text-lg font-bold sm:text-2xl">
        Para criar seu cadastro, precisamos de alguns dados.
      </h2>
      <form class="space-y-4" autocomplete="off">
        <input autocomplete="false" class="hidden" />
        <div
          class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
        >
          <custom-input-component
            class="w-full"
            v-model="user.email"
            label="Email"
            placeholder="ontickerson@ontick.com.br"
            name="email"
            autocomplete="email"
            type="email"
          />
        </div>
        <div
          class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
        >
          <custom-input-component
            class="w-full"
            v-model="user.name"
            label="Nome completo"
            placeholder="Ontickerson Moneymaker"
            name="name"
            autocomplete="full-name"
          />
          <custom-input-component
            class="w-full"
            v-model="user.cpf"
            label="CPF"
            placeholder="Ex.: 123.456.789-01"
            mask="###.###.###-##"
            name="CPF"
            autocomplete="cpf"
          />
        </div>
        <div
          class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
        >
          <!-- <custom-input-component
            class="w-full"
            v-model="user.birthday"
            label="Data de nascimento"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            name="birthday"
            autocomplete="birthday"
          /> -->
          <custom-input-component
            class="w-full"
            v-model="user.phone1"
            label="Telefone principal"
            placeholder="(xx) 55555-5555"
            type="tel"
            name="phone"
            :mask="
              user.phone1.length === 15 ? '(##) #####-####' : '(##) ####-####'
            "
            :maxlength="15"
            autocomplete="phone"
          />
          <!-- <custom-input-component
            class="w-full"
            v-model="user.phone1"
            label="Telefone alternativo"
            placeholder="(xx) 55555-5555"
            type="tel"
            name="alternative-phone"
            :mask="
              user.phone2.length === 15 ? '(##) #####-####' : '(##) ####-####'
            "
            :maxlength="15"
            autocomplete="alternative-phone"
          /> -->
        </div>
        <!-- <div
          class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
        >
          <div class="w-full space-y-2">
            <custom-input-component
              class="w-full"
              v-model="user.password"
              label="Senha"
              placeholder="Digite sua senha"
              type="password"
              name="new-password"
              autocomplete="new-password"
            />
            <div class="flex flex-wrap items-center gap-2">
              <div
                v-for="item in passwordValidation"
                :key="item.label"
                class="whitespace-nowrap rounded px-2 py-1 text-sm"
                :class="
                  item.value
                    ? 'bg-ontick-green-600 text-ontick-carbon-900'
                    : 'bg-ontick-steel-500 text-gray-400'
                "
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div
          class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
        >
          <custom-input-component
            class="w-full"
            v-model="user.confirmPassword"
            label="Confirmar senha"
            placeholder="Digite novamente a sua senha"
            type="password"
            name="confirm-password"
            autocomplete="confirm-password"
            :error="
              !passwordConfirmed &&
              user.passwordTouched &&
              user.confirmPasswordTouched
            "
            :errorMessage="'Senhas não correspondentes'"
          />
        </div> -->
      </form>
    </div>
    <div class="flex w-full items-center justify-end">
      <transition name="fade">
        <button
          @click="$emit('registered')"
          class="text-ontick-carbon-900 bg-ontick-blue-600 w-full rounded py-2 px-12 text-sm font-semibold shadow filter transition-all hover:brightness-125 sm:w-auto"
        >
          Avançar
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import customInputComponent from "./custom-input.component.vue";

export default {
  components: { customInputComponent },

  data() {
    return {
      user: {
        email: "",
        name: "",
        cpf: "",
        birthday: "",
        phone1: "",
        phone2: "",
        password: "",
        passwordTouched: false,
        confirmPassword: "",
        confirmPasswordTouched: false,
      },
    };
  },

  computed: {
    passwordValidation() {
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      return [
        {
          label: "Maiúsculas",
          value: /[A-Z]/.test(this.user.password),
        },
        {
          label: "Minúsculas",
          value: /[a-z]/.test(this.user.password),
        },
        {
          label: "Números",
          value: /\d/.test(this.user.password),
        },
        {
          label: "Caracteres especiais",
          value: format.test(this.user.password),
        },
        {
          label: "8 caracteres",
          value: this.user.password?.length >= 8,
        },
      ];
    },
    passwordIsValid() {
      return this.passwordValidation.every((item) => item.value === true);
    },
    passwordConfirmed() {
      return this.user.password === this.user.confirmPassword;
    },
  },

  watch: {
    user: {
      deep: true,
      handler(val) {
        if (val.password) {
          this.user.passwordTouched = true;
        }
        if (val.confirmPassword) {
          this.user.confirmPasswordTouched = true;
        }
        if (val.email) {
          this.$emit("emailInput", val.email);
        }
      },
    },
  },
};
</script>

<style></style>
